import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'en',
  messages: {
    es: {
      // Login
      enable_2fa: '¿Quieres activar 2FA?  (autenticación en dos fases)',
      opt_resend_msg: 'Se ha reenviado su código.',
      opt_security_msg_01: 'Para mayor seguridad, debera verificar su identidad.',
      opt_security_msg_02: 'Hemos enviado un código de verificación a su correo electrónico.',
      verify_code: 'Verificar código',
      resend_code_email: 'Reenviar código a mi correo',
      resend_code_whatsapp: 'Reenviar código a mi Whatsapp',
      verification_code: 'Código de verificación',
      msg_helpus_safeguard_account: 'Ayúdanos a proteger tu cuenta',
      mensaje_login: 'Acceso al Sistema',
      ingresar: 'Ingresar',
      mensaje_olvidar_contrasena: '¿Olvidaste tu contraseña?',
      mensaje_link_restablecer1: 'Da click',
      mensaje_link_restablecer2: 'aquí',
      mensaje_link_restablecer3: 'para restablecerla.',
      msg_password_reset: 'Ingrese su E-Mail y a continuación le enviaremos una contraseña temporal.',
      msg_password_reset_done1: 'Le hemos enviado una contraseña temporal por E-Mail.',
      msg_password_reset_done2: '¡Deberías recibir el correo en breve!',
      Bienvenido: 'Bienvenido',
      agregar: 'Agregar',
      modificar: 'Modificar',
      crear: 'Crear',
      cerrar: 'Cerrar',
      Buscar: 'Buscar',
      id: 'ID',
      ningun_resultado_1: 'La búsqueda de',
      ningun_resultado_2: 'no tiene coincidencias',
      prep_de: 'de',
      filas_por_pagina: 'Filas por Página',
      todos: 'Todos',
      region: 'es-MX',
      Ayuda: 'Centro de Ayuda',
      Administrador: 'Administrador',
      Vigilante: 'Vigilante',
      SuperAdministrador: 'SuperAdministrador',
      // Menú Empleado
      Historial_Invitaciones_Enviadas: 'Historial de Invitaciones Enviadas',
      Historial_Invitaciones_Recibidas: 'Historial de Invitaciones Recibidas',
      Historial_Accesos: 'Historial de Accesos',
      Historial_Accesos_Trabajadores: 'Historial de Accesos Trabajadores',
      Historial_Accesos_Contratistas: 'Historial de Accesos Contratistas',
      Historial_Accesos_Biometrico: 'Historial de Accesos por Biométrico',
      Historial: 'Historial',
      Historial_avanzado: 'Historial Avanzado',
      // Menú Vigilante
      bitacora: 'Bitácora',
      entradas_salidas: 'Acceso/Salida',
      check_in_time: 'Hora de Entrada',
      check_out_time: 'Hora de Salida',
      acceso_sin_codigo: 'Acceso sin Código',
      historial_accesos_sin_codigo: 'Historial de Accesos sin Código',
      // Menú Administrador
      Invitaciones: 'Invitaciones',
      Accesos: 'Accesos',
      firma_salida: 'Firmar Pase de Salida',
      firmado: 'Firmado',
      no_firmado: 'No Firmado',
      firmar: 'Firmar',
      mensaje_pase_salida_firmado: 'Pase de salida firmado con éxito.',
      no_registros_pase_salida: 'No hay registros de acceso.',
      mensaje_pase_salida: 'Personas dentro de la Empresa',
      Casetas: 'Casetas',
      Vigilantes: 'Vigilantes',
      boton_emergencia: 'Botón de Emergencia',
      // Empleados
      Empleados: 'Empleados',
      AnadirEmpleado: 'Añadir Empleado',
      mensaje_empleado_alta: 'Empleado dado de Alta Correctamente.',
      mensaje_empleado_modificado: 'Empleado Modificado Correctamente.',
      Area: 'Área',
      Nombre: 'Nombre(s)',
      Apellido: 'Apellido(s)',
      Invitacion: 'Invitación',
      puede_enviar: 'Puede enviar invitaciones',
      rented_house: 'Casa rentada',
      renting_house: 'Active la casilla si la persona está rentando la casa.',
      mr_personal_data: 'Datos personales',
      mr_contact: 'Contacto',
      mr_housing_permissions: 'Vivienda y permisos',
      mr_documents: 'Documentos',
      mr_access: 'Acceso',
      mr_is_director: 'Director de mesa directiva',
      mr_is_director_hint: 'Otorga al residente el permiso de pertenecer a la mesa directiva.',
      extension: 'Extensión',
      ine_frente: 'Imagen frente Identificación',
      foto_ine: 'Identificación Oficial con Foto (INE, Licencia de Conducir)',
      ine_atras: 'Imagen atrás Identificación',
      celular: 'Celular',
      password: 'Contraseña',
      current_password: 'Contraseña Actual',
      new_password: 'Contraseña Nueva',
      password_new_confirm: 'Confirmar Contraseña Nueva',
      msg_cambio_password: 'Contraseña cambiada Correctamente.',
      password_confirm: 'Confirmar contraseña',
      Activo: 'Activo',
      Inactivo: 'Inactivo',
      // Casetas
      anadir_caseta: 'Añadir Caseta',
      mensaje_caseta_alta: 'Caseta Agregada Correctamente',
      mensaje_caseta_modificada: 'Caseta Modificada Correctamente.',
      mensaje_caseta_eliminada: 'Caseta Eliminada Correctamente.',
      // Vigilantes
      anadir_vigilante: 'Añadir Vigilante',
      mensaje_vigilante_alta: 'Vigilante Agregado Correctamente.',
      mensaje_vigilante_modificado: 'Vigilante Modificado Correctamente.',
      mensaje_vigilante_eliminado: 'Vigilante Eliminado Correctamente.',
      mostrar_info_invit: 'Mostrar información de la invitación',
      info_invitation: 'INFORMACIÓN DE LA INVITACIÓN',
      info_residente: 'INFORMACIÓN DEL RESIDENTE',
      info_invitado: 'INFORMACIÓN DEL INVITADO',
      info_worker: 'INFORMACIÓN DEL TRABAJADOR',
      info_contractor: 'INFORMACIÓN DEL CONTRATISTA',
      info_anfitrion: 'INFORMACIÓN DEL ANFITRIÓN',
      info_access: 'INFORMACIÓN DE ACCESO',
      datos_coche: 'Datos del automóvil',
      guardar: 'Guardar',
      acceso: 'Acceso',
      complete_register: 'Completar registro',
      registrar_salida: 'Registrar salida',
      form_salida: 'Formulario Salida',
      mensaje_alta_acceso_in: 'Acceso Registrado Correctamente.',
      mensaje_alta_acceso_out: 'Salida Registrada Correctamente.',
      mensaje_qr_no_valido: 'Código QR, no válido.',
      mensaje_qr_multiple: 'Algo salío mal, varios registros con mismo Código QR.',
      mensaje_qr_no_valido_fraccionamiento: 'Esta invitación no corresponde a este Fraccionamiento.',
      mensaje_acceso_completo: 'Ya se completó el Acceso con la Invitación Correspondiente.',
      mensaje_alta_acceso_without: 'Acceso Registrado Correctamente.',
      // Residentes
      anadir_residente: 'Añadir Residente',
      mensaje_residente_alta: 'Residente Agregado Correctamente.',
      mensaje_residente_modificado: 'Residente Modificado Correctamente.',
      mensaje_residente_eliminado: 'Residente Eliminado Correctamente.',
      // Trajadores
      worker: 'Trabajador',
      workers: 'Trabajadores',
      add_worker: 'Añadir Trabajador',
      msg_worker_added: 'Trabajador Agregado Correctamente.',
      msg_worker_update: 'Trabajador Modificado Correctamente.',
      msg_worker_deleted: 'Trabajador Eliminado Correctamente.',
      msg_guest_deleted: 'Invitado Eliminado Correctamente.',

      // Contratistas
      contractor: 'Contratista',
      contractors: 'Contratistas',
      add_contractor: 'Añadir Contratista',
      msg_contractor_added: 'Contratista Agregado Correctamente.',
      msg_contractor_update: 'Contratista Modificado Correctamente.',
      msg_contractor_deleted: 'Contratista Eliminado Correctamente.',

      // Invitados
      mensaje_invitado_alta: 'Invitado Agregado Correctamente.',
      // Invitación
      Empleado: 'Empleado',
      fecha_hora: 'Fecha y Hora de la Invitación',
      fecha_inv: 'Fecha de la Invitación',
      fecha_expiracion: 'Fecha de Expiración',
      fecha_inicial: 'Fecha Inicial',
      fecha_final: 'Fecha Final',
      access_report: 'Reporte de Accesos',
      generate_report: 'Generar Reporte',
      no_access_records: 'No hay accesos en el rango seleccionado',
      invalid_date_range: 'La fecha inicial no puede ser mayor a la final',
      msg_no_permission_worker: 'No tienes permiso para consultar este trabajador',
      msg_worker_not_found: 'El trabajador no existe',
      entrada: 'Entrada',
      salida: 'Salida',
      guardhouse_in: 'Caseta de Entrada',
      guardhouse_out: 'Caseta de Salida',
      comentarios: 'Comentarios',
      nuevo: 'NUEVO',
      worker_access_reports: 'Reportes de accesos de trabajadores',
      worker_access_reports_announcement: 'Ahora puedes consultar y descargar los registros de entrada y salida de cada trabajador por rango de fechas.',
      mas_tarde: 'Más tarde',
      conocer_mas: 'Conocer más',
      creation_date: 'Fecha de creación',
      finish_date: 'Fecha de finalización',
      hora_inv: 'Hora de la Invitación',
      Asunto: 'Asunto',
      placeholder_asunto: 'Escribe el Asunto de la Invitación',
      mensaje_equipo: 'Equipo de seguridad requerido:',
      equipo_seguridad: 'Equipo',
      mensaje_vehiculo: '¿Acceso con vehículo?',
      enviar_codigo: 'Enviar Código',
      Notas: 'Notas',
      no_notes: 'Sin notas',
      placeholder_notas: 'Escribe Notas extras para la Invitación',
      Si: 'Si',
      invitación_referido: 'Invitación Referido',
      ininvitación_normal: 'Invitación',
      mensaje_invitacion_alta: 'Invitación Enviada Correctamente.',
      // Empresas
      Empresas: 'Empresas',
      AnadirFraccionamiento: 'Añadir Fraccionamiento',
      telefono: 'Teléfono',
      logotipo: 'Logotipo',
      pagina_web: 'Página Web',
      clasificacion: 'Clasificación',
      latitud: 'Latitud',
      longitud: 'Longitud',
      url_mapa: 'URL del Mapa',
      vigencia: 'Vigencia',
      Parque: 'Parque',
      mensaje_empresa_alta: 'Fraccionamiento dada de Alta Correctamente.',
      mensaje_empresa_modificado: 'Fraccionamiento Modificado Correctamente.',
      // Fraccionamientos
      Fraccionamientos: 'Fraccionamientos',
      Fraccionamiento: 'Fraccionamiento',
      AnadirFraccionamientos: 'Añadir Fraccionamientos',
      nombre: 'Nombre',
      direccion: 'Dirección',
      mensaje_parque_alta: 'Parque dado de alta Correctamente.',
      mensaje_parque_modificado: 'Parque Modificado Correctamente.',
      // Administradores
      Administradores: 'Administradores',
      anadir_administrador: 'Añadir Administrador',
      anadir_main_resident: 'Añadir Residente Principal',
      Empresa: 'Empresa',
      mensaje_administrador_alta: 'Administrador dado de Alta Correctamente.',
      mensaje_administrador_modificado: 'Administrador Modificado Correctamente.',
      mensaje_administrador_eliminada: 'Administrador Eliminado Correctamente.',
      mensaje_mainresident_alta: 'Residente Principal dado de Alta Correctamente.',
      mensaje_mainresident_modificado: 'Residente Principal Modificado Correctamente.',
      mensaje_mainresident_eliminado: 'Residente Principal Eliminado Correctamente.',
      mensaje_users_alta: 'Usuarios Validados Correctamente.',
      mensaje_users_baja: 'Usuarios Eliminados Correctamente.',
      mensaje_accessnocode_baja: 'Registro(s) Eliminado(s) Correctamente.',
      mensaje_email_sent: 'Email enviado correctamente.',
      mensaje_users_activados: 'Usuarios Activados Correctamente.',
      mensaje_users_unblocked: 'Usuarios Desbloqueados Correctamente.',
      mensaje_users_desactivados: 'Usuarios Desactivados Correctamente.',
      mensaje_users_blocked: 'Usuarios Bloqueados Correctamente.',
      // Relacionar Casas para estado de cuenta
      msg_relate_home_add: 'Casa Asociada Correctamente.',
      msg_lot_add: 'Lote Agregado Correctamente.',
      msg_relate_home_update: 'Registro Modificada Correctamente.',
      msg_relate_home_delete: 'Registro Eliminada Correctamente.',
      // Directorio
      add_directory: 'Añadir',
      mensaje_directory_alta: 'Registro Agregada Correctamente.',
      mensaje_directory_modificado: 'Registro Modificada Correctamente.',
      mensaje_directory_eliminada: 'Registro Eliminada Correctamente.',
      // Áreas
      Areas: 'Áreas',
      mensaje_casas_importadas: 'Casas importadas Correctamente.',
      account_statements_imported_correctly: 'Estados de cuenta importados Correctamente.',
      anadir_casa: 'Añadir Casa',
      mensaje_casa_alta: 'Casa Agregada Correctamente.',
      mensaje_casa_modificado: 'Casa Modificada Correctamente.',
      mensaje_casa_eliminada: 'Casa Eliminada Correctamente.',
      // Paqueteria
      mensaje_paqueteria_alta: 'Paquete agregado correctamente.',
      mensaje_paqueteria_entregado: 'Paquete(s) entregado(s) correctamente.',
      // Servico de Agua
      water_service: 'Servicio de Agua',
      msg_water_service_delivered: 'Servicio(s) de Agua entregado(s) correctamente.',
      request_water_pipe: 'Solicitar pipa de agua',
      request_sent_successfully: 'Solicitud enviada correctamente',
      msg_water_service_request_sent: 'Su solicitud está siendo atendida.',
      // Notices
      Notices: 'Comunicados',
      add_notice: 'Añadir Comunicado',
      msg_added_notice: 'Comunicado agregada correctamente.',
      msg_notice_updated: 'Comunicado modificada correctamente.',
      msg_notice_deleted: 'Comunicado eliminada correctamente.',
      // Reports
      Reports: 'Reportes',
      add_report: 'Añadir Reporte',
      msg_added_report: 'Reporte agregada correctamente.',
      msg_report_updated: 'Reporte modificada correctamente.',
      msg_report_deleted: 'Reporte eliminada correctamente.',
      // Contactos
      contactos: 'Contactos',
      anadir_contacto: 'Añadir Contacto',
      mensaje_contacto_alta: 'Contacto Agregado Correctamente.',
      mensaje_contacto_modificado: 'Contacto Modificado Correctamente.',
      // Grupos
      grupos: 'Grupos',
      anadir_grupo: 'Añadir Grupo',
      mensaje_grupo_alta: 'Grupo Agregado Correctamente.',
      mensaje_grupo_modificado: 'Grupo Modificado Correctamente.',
      mensaje_grupo_delete: 'Grupo Eliminado Correctamente',
      eliminar: 'Eliminar',
      // ContactosXGrupo
      contactosXgrupo: 'Contactos Por Grupo',
      mensaje_contactoXgrupo_alta: 'Contacto Agregado Correctamente al Grupo.',
      mensaje_contactoXgrupo_delete: 'Contacto Eliminado del Grupo Correctamente.',
      // Invitaciones
      Filtrar: 'Filtrar',
      select_fecha: 'Seleccionar fecha:',
      mostrando_inv_dia: 'Mostrando invitaciones del día:',
      mostrando_historial_dia: 'Mostrando Historial del día:',
      Fecha: 'Fecha',
      Visitante: 'Visitante',
      Anfitrion: 'Anfitrión',
      hora_acceso: 'Hora de Acceso',
      hora_salida: 'Hora de Salida',
      Tipo: 'Tipo',
      no_registros_invit: 'No hay registros de invitaciones para ese día.',
      // Accesos
      no_registros_accesos: 'No hay registros de accesos para ese día.',
      // Accesos/Salidas
      mensaje_acercar_QR: 'Acerca el código QR a la cámara.',
      Leer: 'Leer',
      enviar: 'Enviar',
      selecciona_caseta: 'Selecciona una Caseta',
      aceptar: 'Aceptar',
      no_resultados: 'Ningún Resultado',
      page_not_found: 'Página No Encontrada.!!!',
      page_not_found1: 'La URL',
      page_not_found2: 'solicitada no se encontró en este servidor.',
      inicio: 'Inicio',
      atras: 'Atrás',
      preregistro: 'Preregistro',
      registro_exito: 'Datos Enviados Correctamente',
      self_validate_exito: 'Datos Actualizados Correctamente',
      msj_cerrar_pagina: 'Tus datos están en proceso de Validación.',
      msj2_cerrar_pagina: 'Una vez validados se te notificará por SMS y/o E-Mail',
      msj3_cerrar_pagina: 'Gracias por validar tu información.',
      msj_cerrar_pagina_complemento: ' Puede cerrar esta página.',
      identidad_exito: 'Identidad Confirmada Correctamente',
      identidad_exito2: 'Gracias por Confirmar Identidad',
      identidad_desconocido: 'Invitado No reconocido.',
      identidad_desconocido2: 'En breve se eliminará este Invitado del Sistema.',
      pgt_seguro: '¿Está seguro que no conoce al invitado?',
      foto_perfil: 'Foto de Perfil',
      no_foto_perfil: 'Omitir Foto',
      confirmar_identidad: 'Confirmar Identidad',
      msg_know_guest: '¿Reconoce al Invitado?',
      msg_notificacion_anfitrion: 'Se ha enviado una Notificación al Anfitrión.',
      estado: 'Estado',
      current: 'Vigente',
      canceled: 'Cancelada',
      in_progress: 'En Proceso',
      done: 'Finalizado',
      adentro: 'Adentro',
      completado: 'Completado',
      subir_imagen: 'Subir Imagen',
      update_image: 'Actualizar Imagen',
      qr_code: 'Código QR',
      msg_qr_code: 'Introduce el Código QR',
      invitados: 'Invitado(s)',
      invitado: 'Invitado',
      invitados_no_confirmados: 'Invitado(s) Pendiente(s)',
      placeholder_invitados: 'Buscar por E-Mail',
      placeholder_invitados2: 'Buscar por Nombre o Apellido',
      placeholder_empresas: 'Buscar por Empresa',
      add_new_contact: 'Añadir Nuevo Contacto',
      sign_up_new_contact: 'Registrar Nuevo Contacto',
      add_new_employee: 'Añadir Nuevo Empleado',
      invitacion_grupal: 'Invitación Grupal',
      pagina_caduca: 'Esta Página ha Expirado.',
      msg_update_data: 'Gracias por tomarte el tiempo de actualizar tus datos.',
      aviso: 'Aviso',
      cancelar: 'Cancelar',
      detalle: 'Detalle',
      detalle_invit: 'Detalle de la Invitación',
      detalle_invit_recibidas: 'Detalle de la Invitación Recibida',
      detalle_access: 'Detalles del Acceso',
      detalle_access_without_code: 'Detalles del Acceso sin Código',
      pendiente: 'Pendiente',
      info_acceso: 'INFORMACIÓN DEL ACCESO',
      fecha_hora_acceso_in: 'Fecha y Hora del Acceso',
      fecha_hora_acceso_out: 'Fecha y Hora de Salida',
      pase_salida: 'Pase de Salida',
      confirmar: 'Confirmar',
      email_admin: 'E-Mail del Administrador',
      lbl_invit_empresarial: 'Invitación Empresarial',
      lbl_host_company: 'Empresa Anfitrión',
      add_equipo_seguridad: 'Agregar Equipo de Seguridad',
      mensaje_areas_equipo_alta: 'Equipo de Seguridad Agregada Correctamente.',
      mensaje_areas_equipo_update: 'Equipo de Seguridad Modificado Correctamente.',
      mensaje_areas_equipo_delete: 'Equipo de Seguridad Eliminado Correctamente.',
      lbl_invitacion_recurrente: 'Invitación Recurrente',
      Lunes: 'Lunes',
      Martes: 'Martes',
      Miercoles: 'Miércoles',
      Jueves: 'Jueves',
      Viernes: 'Viernes',
      Sabado: 'Sábado',
      Domingo: 'Domingo',
      lbl_selecciona_dias: 'Selecciona los días',
      access_days: 'Días de acceso',
      normal: 'Normal',
      empresarial: 'Empresarial',
      recurrente: 'Recurrente',
      msg_eliminar_empleado: '¿Está seguro de eliminar al Empleado?',
      msg_eliminar_invitacion: '¿Está seguro de eliminar la invitación?',
      msg_cancelar_invitacion: '¿Está seguro de cancelar la invitación?',
      msg_eliminar_invitacion_2: 'Esta acción no se puede deshacer.',
      mensaje_invitacion_delete: 'Invitación Eliminada Correctamente.',
      mensaje_invitacion_canceled: 'Invitación Cancelada Correctamente.',
      mensaje_empleado_delete: 'Empleado Eliminada Correctamente.',
      dias_validos: 'Días Válidos',
      empresa_procedencia: 'Empresa del Invitado',
      mg_enviado: 'Mensaje Enviado Correctamente',
      lbl_emergencia: 'Aviso: Se enviará un mensaje de Emergencia a todos los invitados dentro de la Empresa.',
      msg: 'Mensaje',
      recortar: 'Recortar',
      recortar_imagen: 'Recortar Imagen',
      frente: 'Frente',
      reverso: 'Atrás',
      siguiente: 'Siguiente',
      msg_no_days: 'Debe de seleccionar al menos un día para continuar.',
      cambiar_permisos: 'Cambiar Permisos',
      cambiar_contrasena: 'Cambiar Contraseña',
      move_up_user_to_resident: 'Usuario -> Residente',
      move_up_user_to_guard: 'Usuario -> Vigilante',
      move_up_user_to_manager: 'Usuario -> Administrador',
      move_up_user_to_main_resident: 'Usuario -> Residente Principal',
      usuarios: 'Usuarios',
      msg_cambio_permisos: 'Permisos cambiados Correctamente.',
      msg_invitacion_confirmada: 'Invitación Confirmada Correctamente',
      asistira: '¿Asistirá?',
      print_name_tag: 'Imprimir Gafete',
      // Footer
      a_cerca_de: 'Acerca de',
      equipo: 'Equipo',
      servicios: 'Servicios',
      contacto: 'Contacto',
      sign_up_house: 'Registrar Vivienda',
      numero_casa: 'Número de Casa',
      nombre_calle: 'Nombre de la Calle',
      agregar_residente: 'Agregar Residente',
      editar_residente: 'Editar Residente',
      enviar_datos: 'Enviado Datos ...',
      intrare_residencial: 'Intrare Residencia',
      validar_datos_vivienda: 'Validar Datos de la Vivienda',
      datos_vivienda: 'Datos de la Vivienda',
      datos_residente_principal: 'Datos del Residente Principal',
      datos_residentes: 'Datos de los Residentes',
      detalle_residente: 'Detalles del Residente',
      msg_reconoce_residentes: '¿Reconoce a los Residentes?',
      continuar: 'Continuar',
      paso: 'Paso',
      acciones: 'Acciones',
      configuracion: 'Configuración',
      host_photo: 'Foto del anfitrión',
      casas: 'Casas',
      who_authorized: '¿Quién autorizó?',
      residente_principal: 'Residente Principal',
      residentes: 'Residentes',
      residente: 'Residente',
      main_residents: 'Residentes Principales',
      msg_eliminar_registros: '¿Está seguro de eliminar el/los registro(s) seleccionado(s)?',
      msg_eliminar_casa: '¿Está seguro de eliminar la Casa?',
      msg_delete_lot: '¿Está seguro de quitar el Lote?',
      msg_eliminar_directory: '¿Está seguro de eliminar el Registro?',
      msg_delete_notice: '¿Está seguro de eliminar el Comunicado?',
      msg_delete_report: '¿Está seguro de eliminar el Reporte?',
      msg_eliminar_caseta: '¿Está seguro de eliminar la Caseta?',
      msg_delete_manager: '¿Está seguro de eliminar al Administrador?',
      msg_delete_guard: '¿Está seguro de eliminar al Vigilante?',
      msg_delete_resident: '¿Está seguro de eliminar al Residente?',
      msg_delete_worker: '¿Está seguro de eliminar al Trabajador?',
      msg_delete_contractor: '¿Está seguro de eliminar al Contratista?',
      msg_delete_guest: '¿Está seguro de eliminar al Invitado?',
      msg_delete_main_resident: '¿Está seguro de eliminar al Residente Principal?',
      msg_enable_main_resident: '¿Está seguro de Activar al Residente Principal?',
      msg_unlock_main_resident: '¿Está seguro de Desbloquear al Residente Principal?',
      msg_disable_main_resident: '¿Está seguro de Desactivar al Residente Principal?',
      msg_block_main_resident: '¿Está seguro de Bloquear al Residente Principal?',
      msg_accion_deshacer: 'Esta acción no se puede deshacer.',
      msg_contractor_send_info: 'Se ha enviado la información del contratista al correo electrónico registrado.',
      msg_accion_enviar: 'Se enviará la información registrada al contratista.',
      codigo_pais: 'Código de País',
      ejemplo: 'Ejemplo: ',
      cellphone_wrong: 'Número de Celular Incorrecto',
      msg_usuario_sin_permisos: 'Usuario sin permisos, póngase en contacto con el Administrador.',
      msg_vigilant_sin_permisos: 'Vigilante sin permisos, póngase en contacto con el Administrador.',
      msg_user_delete: 'Usuario Eliminado Correctamente.',
      msg_user_invalidate: 'Se ha notificado al invitado, para corregir sus datos.',
      initialDate: 'Fecha Inicial',
      finalDate: 'Fecha Final',
      add_guest: 'Añadir Invitado',
      access_without_code: 'Acceso sin Código',
      select_video_device: 'Selecciona dispositivo de vídeo',
      start_camera: 'Iniciar Cámara',
      stop_camera: 'Detener Cámara',
      capture_photo: 'Capturar Foto',
      notificaciones: 'Notificaciones',
      canSendEmail: '¿Quieres recibir Correos?',
      canSendSMS: '¿Quieres recibir SMS?',
      notificacion_success: 'Configuración Actualizada Correctamente.',
      rulebook_uploaded_successfully: 'Reglamento subido correctamente.',
      privacy_notice_uploaded_successfully: 'Aviso de privacidad subido correctamente.',
      msg_offline: '¡No hay Conexión a Internet!',
      access_success: 'Acceso Registrado Correctamente.',
      msg_exit_time_registered: 'Hora de salida registrada Correctamente.',
      msg_captura_foto: 'Haga clic sobre el vídeo para capturar la imagen.',
      search_by_number_street_phone: 'Buscar por calle/número de casa/teléfono',
      search_by_number_street: 'Buscar por calle o número de casa',
      search_by_street: 'Buscar por calle',
      search_by_house_number: 'Buscar por Número de Casa',
      search_by_street_house_number: 'Buscar por Calle/Número de Casa',
      search_by_house_number_resident: 'Buscar por Calle/Número de Casa/Nombre Residente',
      search_by_house_street_resident: 'Buscar por Calle/Nombre Residente',
      search_by_name: 'Buscar por Nombre',
      search_by_code: 'Buscar por Código',
      service_catalog: 'Catálogo de Servicios',
      search_by_name_visitor: 'Buscar por Notas o Nombre del Visitante',
      search_by_address_notes_name_guest: 'Buscar por Dirección/Notas/Nombre del Visitante',
      unique_resident: 'Soy el único residente',
      msg_signup_apartment: 'Para iniciar con el Proceso de Registro de Vivienda, es necesario dar de Alta un Residente Principal, y los miembros de su familia.',
      place_holder_housing_units: 'Buscar por nombre',
      validado: 'Validado',
      validar: 'validar',
      msg_confirma_validacion_1: 'Debe de seleccionar ',
      or: 'o',
      msg_confirma_validacion_2: 'para continuar.',
      habitada: 'Habitada',
      deshabitada: 'Deshabitada',
      cambiar_wallpaper: 'Cambiar Imagen de Inicio',
      cambiar_wallpaper_exito: 'Imagen Cambiada Correctamente.',
      activar_desactivar: 'Activar/Desactivar',
      activar: 'Activar',
      desactivar: 'Desactivar',
      defaulter: 'Moroso(a)',
      block_for_non_payment: 'Bloquear/Moroso(a)',
      reactivate: 'Reactivar',
      unlock: 'Desbloquear',
      note_disable_main_resident: 'Nota: Al desactivar al Residente Principal, éste y los residentes que registró no podran enviar invitaciones.',
      note_block_main_resident: 'Al bloquear al Residente Principal se inhabilitarán los servicios de intrare para este como para los Residentes Secundarios.',
      note2_block_main_resident: 'Nota: Una vez que el Residente Principal ha sido bloqueado, deberań pasar 24 hrs para quitar el bloqueo.',
      note_enable_main_resident: 'Nota: Al activar el Residente principal, el Residente principal y los residentes registrados podrán enviar invitaciones.',
      note_unlock_main_resident: 'Nota: Al desbloquear al Residente Principal se habilitarán los servicios de intrare para este, como para los Residentes Secundarios.',
      servicio_suspendido: 'Servicio Suspendido',
      msg_time_unlock: 'No es posible quitar el bloqueo en este momento. Deben pasar 24 horas antes de intentarlo de nuevo. Gracias por tu paciencia.',
      msg_supendido: 'Este mensaje se muestra por cualquiera de las 2 siguientes razones:',
      msg_supendido1: 'Debido a que usted no tiene permisos para enviar invitaciones o',
      msg_supendido2: 'Debido a la falta de pago, el servicio de invitaciones ha sido suspendido.',
      msg_supendido3: 'Para más información comuníquese con su Residente Principal o Administrador del Fraccionamiento.',
      blocked_service: 'Servicio bloqueado',
      dear_user: 'Estimado Usuario',
      msg_blocked_service_01: 'Le informamos que su cuenta ha sido bloqueada debido a un saldo pendiente por el servicio de mantenimiento de su privada.',
      msg_blocked_service_02: 'Para reactivar su cuenta y restaurar el acceso completo a nuestros servicios, le pedimos que se comunique de inmediato con su departamento de Administración de su privada.',
      importar_casas: 'Importar Casas',
      importar: 'Importar',
      selecciona_archivo: 'Selecciona un Archivo de Excel.',
      selecciona_archivo_pdf: 'Selecciona un archivo PDF.',
      archivo: 'Archivo',
      importar_casas_archivo: 'Importar casas desde archivo Excel.',
      import_account_statements_file: 'Importar estados de cuenta desde archivo Excel.',
      msg_importar_casas: 'Nota: El archivo para importar casas debe cumplir con el siguiente formato.',
      mostrar_formato: 'Mostrar formato',
      msg_mi_codigo: 'Mi Código de Acceso',
      descargar: 'Descargar',
      renovar_codigos: 'Actualizar códigos QR',
      renovar_codigos_residentes: 'Actualizar códigos QR de los Residentes',
      msg_update_code_1: 'Permitir la actualización Mensual de Códigos QR de los Residentes de manera automática.',
      msg_update_code_2: 'Nota: Esta actuliazación  se ejecuta el primer día de cada mes a las 3:00 AM.',
      allow: 'Permitir',
      cambios_aplicados: 'Cambios Aplicados Correctamente',
      label: 'Etiqueta',
      classification: 'Clasificación',
      device: 'Dispositivo',
      no_devices: 'Sin Dispositivos',
      no_lots: 'Sin lotes registrados.',
      add_device: 'Añadir Dispositivo',
      device_added_successfully: 'Dispositivo Agregado Correctamente.',
      device_modified_successfully: 'Dispositivo Modificado Correctamente.',
      device_removed_successfully: 'Dispositivo Eliminado Correctamente.',
      lot_removed_successfully: 'Lote Eliminado Correctamente.',
      device_by_guardhouse: 'Dispositovo(s) por Caseta',
      delete: 'Eliminar',
      delete_question: 'Eliminar Pregunta',
      change: 'Modificar',
      show_devices: 'Mostrar Dispositivos',
      show_lots: 'Mostrar lotes',
      details: 'Detalles',
      show_details: 'Mostrar Detalles',
      send_details: 'Enviar Detalles',
      msg_info_details: 'Esta información solo es visible para el Administrador.',
      msg_send_contractor: 'Enviar información del Contratista',
      lanesQR: 'Carriles con Lector de QR',
      lanesCam: 'Carriles con Cámara',
      devices: 'Dispositivos',
      grados: 'Grados',
      msg_can_not_delete_house01: 'No es posible Eliminar la Casa',
      msg_can_not_delete_house02: 'Actualmente un Residente o más la estan ocupando. Elimine primero al Residente.',
      no_records_yet: 'Sin registros todavía.',
      canceled_invitation: '¡INVITACIÓN CANCELADA!',
      msg_canceled_invitation_offline: 'Esta invitación ha sido cancelada por el Anfitrión.',
      msg_canceled_invitation: '¡ACCESO DENEGADO! .Esta invitación ha sido cancelada por el Anfitrión.',
      msg_event_canceled: '¡ACCESO DENEGADO!. Este Evento ha sido cancelada por el Anfitrión.',
      msg_vacation_mode_activate: '¡ACCESO DENEGADO! Por el momento la casa no está recibiendo visitas.',
      msg_out_date: '¡ACCESO DENEGADO! .Esta invitación esta fuera de fecha o ha expirado.',
      msg_out_date2: '¡ACCESO DENEGADO!. Esta invitacion ha expirado.',
      msg_out_date3: '¡ACCESO DENEGADO!. No esta autorizado la entrada para este dia.',
      msg_out_date_worker0: '¡ACCESO DENEGADO!. Este trabajador no tiene autorizado la entrada para este dia.',
      msg_out_date_worker1: '¡ACCESO DENEGADO!. El plazo para acceder de este trabajador ha expirado.',
      msg_out_date_contractor0: '¡ACCESO DENEGADO!. Este contratista no tiene autorizado la entrada para este dia.',
      msg_out_date_contractor1: '¡ACCESO DENEGADO!. El plazo para acceder de este contratista ha expirado.',
      msg_out_date_contractor2: '!ACCESO DENEGADO!. Contratista Bloqueado. Contacte al Administrador del Fraccionamiento.',
      export_to_pdf: 'Exportar a PDF',
      access_report_no_code: 'Reporte de accesos sin código',
      period: 'Período: ',
      page: 'Página ',
      al: ' al ',
      de: ' de ',
      allow_device: 'Permitir dispositivo',
      show_current_invitations: 'Mostrar invitaciones vigentes',
      msg_allow_device: '¿Quiere que el/los Vigilantes inicien sesión desde este navegador?',
      show_house_phones: 'Mostrar teléfonos de casa',
      msg_allow_show_house_phones: '¿Quieres que los Vigilantes puedan ver los teléfonos de las casas?',
      msg_allow_show_current_invitations: '¿Quieres que los Vigilantes puedan ver las invitaciones vigentes del dia?',
      msg_enable_ine_photo: '¿Qué foto del anfitrión quieres que se muestre al Vigilante cuando se despliegue la información de la invitación?',
      info_enable_ine_photo: 'Nota: Al activar esta opción los vigilantes podrán ver la Identificación del invitado, por lo que el trato otorgado a la información presentada es responsabilidad del cliente.',
      booth_registration: 'Registro en caseta',
      notice: 'Comunicado',
      title: 'Titulo',
      comments: 'Comentarios',
      no_comment: 'Sin Comentarios',
      administrator_comments: 'Comentarios del Administrador',
      file: 'Archivo',
      msg_overflow_file: '¡El tamaño del archivo debe ser inferior a 2 MB!',
      report: 'Reporte',
      type_reports: 'Categoria del Reporte',
      choose_category: 'Elige una categoría',
      evidence: 'Evidencia',
      msg_evidence: 'Si quiere agregar una fotografía como evidencia marque la casilla Agregar Archivo y posteriormente seleccione la fotografia.',
      no_vidence: 'No se adjuntó evidencia.',
      directory: 'Directorio',
      show_vehicle_plates: 'Mostrar placas del vehículo',
      vehicle_plates: 'Placas del vehículo',
      send_email_update: 'Enviar E-Mail, validación/actualización de datos',
      hide_video: 'Ocultar video',
      show_video: 'Mostrar video',
      show_qr_code: 'Mostrar código QR',
      display_info_print: 'Visualizar información para imprimir',
      generate_pdf_printing: 'Generar PDF para imprimir',
      number_cards_sheet: 'Número de tarjetas por hoja',
      supplier: 'Proveedor',
      q_supplier: '¿Es proveedor?',
      supplier_mode: 'Modo Proveedor: ',
      msg_supplier: 'Esta persona ha sido invitada en modo proveedor, favor de realizar el protocolo de seguridad para proveedores.',
      tooltip_supplier: 'Si tu visita va a realizar algún servicio o entrega en tu domicilio, indícale al fraccionamiento para agilizar su entrada y que sea realizado el protocolo de seguridad para proveedores.',
      account_statements: 'Estados de Cuenta',
      relate_home: 'Relacionar casa',
      vacation_mode: 'Modo vacaciones: ',
      msg_vacation_mode: 'Por el momento la casa no está recibiendo visitas.',
      allow_access_visitors: 'Permitir acceso a visitantes',
      allow_access_residents: 'Permitir acceso a residentes',
      allow_access_workers: 'Permitir acceso a trabajadores',
      rulebook: 'Reglamento',
      rulebook_upload_tooltip: 'Aquí puedes subir el Reglamento interno del Fraccionamiento',
      privacy_notice: 'Aviso de privacidad',
      privacy_notice_upload_tooltip: 'Aquí puedes subir el Aviso de Privacidad del Fraccionamiento',
      guardhouse_name_checkin: 'Caseta Entrada',
      guardhouse_name_checkout: 'Caseta Salida',
      current_invitations: 'Invitaciones vigentes',
      data_correction_form: 'Formulario corrección datos',
      data_correction: 'Corrección de datos',
      msg_photograph_blurred: 'Fotografía de identificación oficial no se distingue (borrosa)',
      send_correction_request: 'Enviar solicitud de corrección.',
      data_correction_sent: 'Corrección de datos enviada.',
      additional_comments: 'Comentarios adicionales',
      msg_additional_comments: 'Escribir comentarios adicionales. \nNota: estos comentarios se anexaran al correo.',
      additional_person: 'Agregar persona',
      msg_additional_person: 'El invitado viene con más personas',
      show_additional_people: 'Mostrar personas adicionales',
      additional_people: 'Personas adicionales',
      show_all_residents: 'Ver todos los residentes',
      show_secondary_residents: 'Mostrar residentes secundarios',
      msg_no_registered_secondary_residents_yet: 'Este Residente Principal aún no ha registrado Residentes Secundarios.',
      register: 'Registrar',
      register_parcel: 'Registrar paquetería',
      addressee: 'Destinatario',
      guide_number: 'Número de guía',
      company: 'Compañía',
      who_delivered: '¿Quién entregó?',
      who_received: '¿Quien recibió?',
      package_delivery: 'Entrega de paquetes ',
      water_service_delivery: 'Entrega servicio de Agua ',
      parcel: 'Paquetería',
      parcel_capital_letters: 'PAQUETERÍA',
      date_time_receipt: 'Fecha y hora recibo',
      delivery_date_time: 'Fecha y hora entrega',
      date_time_request: 'Fecha y hora de la solicitud',
      in_booth: 'En caseta',
      delivered: 'Entregado',
      requested: 'Solicitado',
      payroll_number: 'Número de nómina',
      email: 'Correo electrónico',
      msg_delete_alert: 'Utilice esta herramienta con precaución ya que una vez que elimine al invitado ya no podrá recuperar su información.',
      guest_management: 'Gestión Invitados',
      event_data: 'Información del Evento',
      event: 'Evento',
      events: 'Eventos',
      event_name: 'Nombre del Evento',
      event_time: 'Hora',
      code: 'Código',
      instructions: 'Instrucciones',
      sincronizar: 'Sincronizar',
      notify_on_no_code_access: 'Notificaciones de accesos sin código',
      notify_on_worker_access: 'Notificaciones de accesos de trabajadores',
      personal_information: 'Información Personal',
      configuration_permissions: 'Configuración de permisos',
      authentication: 'Autenticación',
      identification_photos: 'Fotografías de identificación',
      full_name: 'Nombre Completo',
      error_name_min_two_words: 'El nombre debe contener al menos un apellido (mínimo 2 palabras).',
      pet_registrations: 'Registros de Mascotas',
      pet_name: 'Nombre de Mascota',
      pet_report: 'Reporte de Mascotas Registradas',
      fecha_registro: 'Fecha de Registro',
      receive_marketplace_notifications: '¿Quieres recibir notificaciones del marketplace?',
      visualizar: 'Visualizar',
      // Sistema de Tickets
      sistema_tickets: 'Sistema de Tickets',
      mis_tickets: 'Mis Tickets de Soporte',
      crear_ticket: 'Crear Nuevo Ticket',
      detalles_ticket: 'Detalles del Ticket',
      lista_tickets: 'Lista de Tickets',
      nuevo_ticket: 'Nuevo Ticket',
      titulo: 'Título',
      descripcion: 'Descripción',
      area: 'Área',
      nombre_cliente: 'Nombre del Cliente',
      cliente: 'Cliente',
      fecha_creacion: 'Fecha Creación',
      no_hay_tickets: 'No hay tickets disponibles',
      total_tickets: 'Total de Tickets',
      nuevos: 'Nuevos',
      en_progreso: 'En Progreso',
      resueltos: 'Resueltos',
      etiquetas: 'Etiquetas',
      no_disponible: 'No Disponible',
      foto_no_disponible: 'Foto no disponible',
      debes_iniciar_sesion: 'Debes iniciar sesión para ver tus tickets',
      acceso_no_autorizado: 'Acceso no Autorizado',
      solo_administradores: 'Solo los administradores pueden acceder a esta sección',
      // Preguntas Frecuentes
      preguntas_frecuentes: 'Preguntas Frecuentes',
      buscar_preguntas: 'Buscar preguntas...',
      no_preguntas_encontradas: 'No se encontraron preguntas que coincidan con tu búsqueda',
      ayuda: 'Centro de Ayuda',
      catalog_worker: 'Catálogo de Trabajadores',
      select_worker_deleted: 'Seleccionar un trabajador del catálogo (Opcional)',
      // Encuestas
      surveys: 'Encuestas',
      survey: 'Encuesta',
      add_survey: 'Añadir Encuesta',
      survey_results: 'Resultados de Encuesta',
      survey_title: 'Título de la Encuesta',
      survey_description: 'Descripción',
      survey_start_date: 'Fecha de Inicio',
      survey_end_date: 'Fecha de Fin',
      add_questions: 'Añadir Preguntas',
      survey_questions: 'Preguntas',
      msg_added_survey: 'Encuesta agregada correctamente.',
      msg_survey_updated: 'Encuesta modificada correctamente.',
      msg_survey_deleted: 'Encuesta eliminada correctamente.',
      msg_delete_survey: '¿Está seguro de eliminar la Encuesta?',
      survey_status: 'Estado',
      question_text: 'Pregunta',
      question_type: 'Tipo de Pregunta',
      SINGLE_CHOICE: 'Opción Única',
      MULTIPLE_CHOICE: 'Opción Múltiple',
      TEXT: 'Texto Libre',
      options: 'Opciones',
      add_option: 'Añadir Opción',
      add_question: 'Añadir Pregunta',
      save_questions: 'Guardar Preguntas',
      msg_questions_added: 'Preguntas agregadas correctamente.',
      view_results: 'Ver Resultados',
      close_survey: 'Cerrar Encuesta',
      pending_surveys: 'Votaciones/Encuestas Pendientes',
      answer_survey: 'Responder Encuesta',
      submit_answers: 'Enviar Respuestas',
      msg_survey_submitted_successfully: 'Encuesta respondida correctamente.',
      msg_no_pending_surveys: 'No tienes encuestas pendientes en este momento.',
      survey_preview: 'Vista Previa',
      msg_no_questions_yet: 'Esta encuesta aún no tiene preguntas.',
      download_pdf: 'Descargar PDF',
      voting: 'Votaciones',
      add_voting: 'Añadir Votación',
      voting_title: 'Título de la Votación',
      voting_description: 'Descripción',
      voting_end_date: 'Fecha de Fin',
      voting_question: 'Pregunta',
      voting_question_type: 'Tipo de Pregunta',
      voting_options: 'Opciones',
      msg_added_voting: 'Votación agregada correctamente.',
      common_areas: 'Áreas Comunes',
      common_area: 'Área Común',
      add_common_area: 'Agregar Área Común',
      edit_common_area: 'Editar Área Común',
      delete_common_area: 'Eliminar Área Común',
      msg_delete_common_area: '¿Está seguro de eliminar el Área Común?',
      msg_common_area_added: 'Área Común agregada correctamente.',
      msg_common_area_updated: 'Área Común modificada correctamente.',
      msg_common_area_deleted: 'Área Común eliminada correctamente.',
      name_common_area: 'Nombre Área Común',
      location_common_area: 'Ubicación Área Común',
      description_common_area: 'Descripción Área Común',
      capacity_common_area: 'Capacidad Área Común',
      max_hours_per_reservation: 'Máx. Horas por Reserva',
      reservation_interval: 'Intervalo de Reservación',
      color_calendar: 'Color en Calendario',
      image: 'Imagen',
      has_price: '¿Tiene Costo?',
      requires_authorization: '¿Requiere Autorización?',
      active: '¿Activa?',
      price: 'Precio',
      create_common_area: 'Crear Área Común',
      view_common_areas: 'Ver Áreas Comunes',
      view_common_area_schedule: 'Ver Horario del Área Común',
      save_changes: 'Guardar Cambios',
      reservation: 'Reservaciones',
      // Almacenamiento (Home - Card Administrador)
      almacenamiento: 'Almacenamiento',
      usado: 'Usado',
      disponible: 'Disponible',
      total: 'Total',
      limite: 'Límite',
      este_mes: 'Este mes',
      almacenamiento_historico: 'Almacenamiento histórico',
      almacenamiento_reciente: 'Almacenamiento reciente',
      total_historico: 'Total histórico',
      fotos: 'Fotos',
      documentos: 'Documentos',
      eventos: 'Eventos',
      optimo: 'Óptimo',
      alerta: 'Alerta',
      critico: 'Crítico',
      solicitar_espacio: 'Solicitar más espacio',
      solicitar_almacenamiento: 'Solicitar Almacenamiento Adicional',
      solicitar_almacenamiento_subtitulo: 'Amplía la capacidad de almacenamiento de tu residencial',
      uso_actual: 'Uso actual',
      mas_popular: 'Más popular',
      por_mes: '/mes',
      paquete_descripcion_5gb: 'Almacenamiento adicional',
      paquete_descripcion_10gb: 'Plan recomendado',
      paquete_descripcion_20gb: 'Para más contenido',
      paquete_descripcion_50gb: 'Plan profesional',
      activacion_inmediata: 'Activación inmediata',
      sin_permanencia: 'Sin permanencia',
      facturacion_mensual: 'Facturación mensual',
      soporte_prioritario: 'Soporte prioritario',
      paquete_seleccionado: 'Paquete seleccionado',
      ningun_paquete_seleccionado: 'Selecciona un paquete para continuar',
      solicitud_enviada: 'Tu solicitud del paquete {paquete} ha sido enviada correctamente.',
      error_cargar_almacenamiento: 'Error al cargar almacenamiento',
      verifica_permisos: 'Verifica tus permisos o intenta más tarde',
      reintentar: 'Reintentar',
      cargando_almacenamiento: 'Cargando información de almacenamiento...',
      hace_un_momento: 'Hace un momento',
      error_solicitud_almacenamiento: 'Error al enviar solicitud de almacenamiento',
      almacenamiento_adicional: 'Almacenamiento Adicional',
      duracion_plan: 'Duración del Plan',
      precio_por_mes: 'Precio por mes',
      meses: 'Meses',
      subtotal: 'Subtotal',
      descuento: 'Descuento',
      paquete_descripcion_100gb: 'Plan empresarial',
      paquete_descripcion_200gb: 'Plan premium',
      restricted_people: 'Personas Restringidas',
      communication_channel: 'Chats'
    },
    en: {
      // Login
      enable_2fa: 'Do you want to activate 2FA? (two-factor authentication)',
      opt_resend_msg: 'Your code has been resent.',
      opt_security_msg_01: 'For added security, you must verify your identity.',
      opt_security_msg_02: 'We\'ve sent a verification code to your email.',
      verify_code: 'Verify code',
      resend_code_email: 'Resend code by E-Mail',
      resend_code_whatsapp: 'Resend code by Whatsapp',
      verification_code: 'Verification code',
      msg_helpus_safeguard_account: 'Help us safeguard your account',
      mensaje_login: 'Access to the system',
      ingresar: 'Login',
      mensaje_olvidar_contrasena: 'Did you forget your password?',
      mensaje_link_restablecer1: 'Click ',
      mensaje_link_restablecer2: 'here',
      mensaje_link_restablecer3: 'to reset it.',
      msg_password_reset: 'Enter your E-Mail and then we will send you a temporary password.',
      msg_password_reset_done1: 'We have sent you a temporary password by E-Mail.',
      msg_password_reset_done2: 'You should receive the email shortly!',
      Bienvenido: 'Welcome',
      agregar: 'Add',
      modificar: 'Change',
      crear: 'Create',
      cerrar: 'Close',
      Buscar: 'Search',
      id: 'ID',
      ningun_resultado_1: 'The search for',
      ningun_resultado_2: 'found no results.',
      prep_de: 'of',
      filas_por_pagina: 'Rows per page',
      todos: 'All',
      region: 'en-US',
      Ayuda: 'Help',
      Administrador: 'Manager',
      Vigilante: 'Guard',
      SuperAdministrador: 'SuperManager',
      // Menú Empleado
      Historial_Invitaciones_Enviadas: 'History of invitations Sent',
      Historial_Invitaciones_Recibidas: 'History of invitations received',
      Historial_Accesos_Trabajadores: 'Workers Access History',
      Historial_Accesos_Contratistas: 'Contractors Access History',
      Historial_Accesos_Biometrico: 'Biometric Access History',
      Historial_Accesos: 'Access History',
      Historial: 'Record',
      Historial_avanzado: 'Advanced record',
      // Menú Vigilante
      bitacora: 'Log',
      entradas_salidas: 'Check In/Check Out',
      check_in_time: 'Check in time',
      check_out_time: 'Check out time',
      acceso_sin_codigo: 'Check In Without Code',
      historial_accesos_sin_codigo: 'Access history without code',
      // Menú Administrador
      Invitaciones: 'Invitations',
      Accesos: 'Access',
      firma_salida: 'Sign exit pass',
      firmado: 'Signed',
      no_firmado: 'Unsigned',
      firmar: 'Sign it',
      mensaje_pase_salida_firmado: 'Exit pass signed successfully.',
      no_registros_pase_salida: 'There are no access records.',
      mensaje_pase_salida: 'People within the Company',
      Casetas: 'Guard Houses',
      Vigilantes: 'Guards',
      boton_emergencia: 'Emergency Button',
      // Empleados
      Empleados: 'Employees',
      AnadirEmpleado: 'Add Employee',
      mensaje_empleado_alta: 'Employee Added Successfully.',
      mensaje_empleado_modificado: 'Employee Modified Correctly.',
      Area: 'Area',
      Nombre: 'First Name',
      Apellido: 'Last Name',
      Invitacion: 'Invitation',
      puede_enviar: 'You can send invitations',
      rented_house: 'Rented house',
      renting_house: 'Check the box if the person is renting the house.',
      mr_personal_data: 'Personal information',
      mr_contact: 'Contact',
      mr_housing_permissions: 'Housing and permissions',
      mr_documents: 'Documents',
      mr_access: 'Access',
      mr_is_director: 'Board director',
      mr_is_director_hint: 'Grants the resident the board director permission.',
      extension: 'Extension',
      ine_frente: 'Image front identification',
      foto_ine: 'Official Photo Identification (Driver License, Passport)',
      ine_atras: 'Image back Identification',
      celular: 'Cell phone',
      password: 'Password',
      current_password: 'Current Password',
      new_password: 'New Password',
      password_new_confirm: 'Confirm New Password',
      msg_cambio_password: 'Password changed Successfully.',
      password_confirm: 'Confirm Password',
      Activo: 'Active',
      // Vigilantes
      anadir_vigilante: 'Add Guard',
      mensaje_vigilante_alta: 'Guard Added Successfully.',
      mensaje_vigilante_modificado: 'Guard Modified Successfully.',
      mensaje_vigilante_eliminado: 'Guard Removed Successfully.',
      mostrar_info_invit: 'Show invitation information',
      info_invitation: 'INVITATION INFORMATION',
      info_residente: 'RESIDENT INFORMATION',
      info_worker: 'WORKER INFORMATION',
      info_contractor: 'CONTRACTOR INFORMATION',
      info_invitado: 'GUEST INFORMATION',
      info_anfitrion: 'HOST INFORMATION',
      info_access: 'ACCESS INFORMATION',
      datos_coche: 'Car data',
      guardar: 'Save',
      acceso: 'Access',
      complete_register: 'Complete register',
      registrar_salida: 'Check Out',
      form_salida: 'Exit Form',
      mensaje_alta_acceso_in: 'Registered Access Successfully.',
      mensaje_alta_acceso_out: 'Registered Exit Successfully.',
      mensaje_qr_no_valido: 'QR code, Invalid.',
      mensaje_qr_multiple: 'Something went wrong, multiple records with the same QR Code.',
      mensaje_qr_no_valido_fraccionamiento: 'This invitation does not correspond to this Housing Unit.',
      mensaje_acceso_completo: 'Access has already been completed with the corresponding invitation.',
      mensaje_alta_acceso_without: 'Access Registered Successfully.',
      // Residentes
      anadir_residente: 'Add Resident',
      mensaje_residente_alta: 'Resident Added Successfully.',
      mensaje_residente_modificado: 'Resident Modified Successfully.',
      mensaje_residente_eliminado: 'Resident Removed Successfully.',
      // Trajadores
      worker: 'Worker',
      workers: 'Workers',
      add_worker: 'Add Worker',
      msg_worker_added: 'Worker Added Successfully.',
      msg_worker_update: 'Worker Modified Successfully.',
      msg_worker_deleted: 'Worker Removed Successfully.',
      msg_guest_deleted: 'Guest Removed Successfully.',

      // Contratistas
      contractor: 'Contractor',
      contractors: 'Contractors',
      add_contractor: 'Add Contractor',
      msg_contractor_added: 'Contractor Added Successfully.',
      msg_contractor_update: 'Contractor Modified Successfully.',
      msg_contractor_deleted: 'Contractor Removed Successfully.',

      // Guest
      mensaje_invitado_alta: 'Guest Added Successfully.',
      // Invitación
      Empleado: 'Employee',
      fecha_hora: 'Date and Hour for Invitation',
      fecha_inv: 'Date for Invitation',
      fecha_expiracion: 'Expiration date',
      fecha_inicial: 'Initial date',
      fecha_final: 'Final date',
      access_report: 'Access Report',
      generate_report: 'Generate Report',
      no_access_records: 'No access records in the selected range',
      invalid_date_range: 'Initial date cannot be after the final date',
      msg_no_permission_worker: 'You do not have permission to view this worker',
      msg_worker_not_found: 'Worker not found',
      entrada: 'Check-in',
      salida: 'Check-out',
      guardhouse_in: 'Entry Guardhouse',
      guardhouse_out: 'Exit Guardhouse',
      comentarios: 'Comments',
      nuevo: 'NEW',
      worker_access_reports: 'Worker access reports',
      worker_access_reports_announcement: 'You can now view and download each worker’s check-in and check-out records by date range.',
      mas_tarde: 'Later',
      conocer_mas: 'Learn more',
      creation_date: 'Creation Date',
      finish_date: 'Finish date',
      hora_inv: 'Hour for Invitation',
      Asunto: 'Subject',
      placeholder_asunto: 'Write the Subject of the Invitation',
      mensaje_equipo: 'Required safety equipment:',
      equipo_seguridad: 'Equipment',
      mensaje_vehiculo: 'Access with vehicle?',
      enviar_codigo: 'Send Code',
      Notas: 'Notes',
      no_notes: 'No Notes',
      placeholder_notas: 'Write Extra Notes for the Invitation',
      Si: 'Yes',
      invitación_referido: 'Referred Invitation',
      ininvitación_normal: 'Invitation',
      mensaje_invitacion_alta: 'Invitation Sent Successfully.',
      // Empresas
      Empresas: 'Companies',
      AnadirFraccionamiento: 'Add Housing Unit',
      telefono: 'Telephone',
      logotipo: 'Logotype',
      pagina_web: 'Web page',
      clasificacion: 'Classification',
      latitud: 'Latitude',
      longitud: 'Longitude',
      url_mapa: 'URL map',
      vigencia: 'Expiration Date',
      Parque: 'Park',
      mensaje_empresa_alta: 'Housing Unit Added Successfully.',
      mensaje_empresa_modificado: 'Housing Unit Modified Successfully.',
      // Parques
      Fraccionamientos: 'Housing Units',
      Fraccionamiento: 'Housing Unit',
      AnadirFraccionamientos: 'Add housing unit',
      nombre: 'Name',
      direccion: 'Address',
      mensaje_parque_alta: 'Park Added Successfully.',
      mensaje_parque_modificado: 'Park Modified Successfully.',
      // Administradores
      Administradores: 'Managers',
      anadir_administrador: 'Add Manager',
      anadir_main_resident: 'Add Main Resident',
      Empresa: 'Company',
      mensaje_administrador_alta: 'Manager Added Successfully',
      mensaje_administrador_modificado: 'Manager Modified Successfully.',
      mensaje_administrador_eliminada: 'Manager Removed Successfully.',
      mensaje_mainresident_alta: 'Main Resident Added Successfully.',
      mensaje_mainresident_modificado: 'Main Resident Modified Successfully.',
      mensaje_mainresident_eliminado: 'Main Resident Removed Successfully.',
      mensaje_users_alta: 'Validated Users Successfully.',
      mensaje_users_baja: 'Users Deleted Successfully.',
      mensaje_accessnocode_baja: 'Record(s) Deleted Successfully.',
      mensaje_email_sent: 'Email sent successfully.',
      mensaje_users_activados: 'Users enabled successfully.',
      mensaje_users_unblocked: 'Users Unblocked successfully.',
      mensaje_users_desactivados: 'Users disabled successfully.',
      mensaje_users_blocked: 'Users Blocked successfully.',
      // Áreas
      Areas: 'Areas',
      mensaje_casas_importadas: 'Successfully imported houses.',
      account_statements_imported_correctly: 'Account statements imported successfully.',
      anadir_casa: 'Add House',
      mensaje_casa_alta: 'House Added Successfully.',
      mensaje_casa_modificado: 'House Modified Successfully.',
      mensaje_casa_eliminada: 'House Removed Successfully.',
      // Relacionar Casas para estado de cuenta
      msg_relate_home_add: 'Associated House successfully.',
      msg_lot_add: 'Lot Added Successfully.',
      msg_relate_home_update: 'Record Modified Successfully.',
      msg_relate_home_delete: 'Record Removed Successfully.',
      // Directorio
      add_directory: 'Add',
      mensaje_directory_alta: 'Record Added Successfully.',
      mensaje_directory_modificado: 'Record Modified Successfully.',
      mensaje_directory_eliminada: 'Record Removed Successfully.',
      // Paqueteria
      mensaje_paqueteria_alta: 'Package added successfully.',
      mensaje_paqueteria_entregado: 'Package delivered successfully.',
      // Servico de Agua
      water_service: 'Water service',
      msg_water_service_delivered: 'Water service delivered successfully.',
      request_water_pipe: 'Request water pipe',
      request_sent_successfully: 'Request sent successfully',
      msg_water_service_request_sent: 'Your request is being processed.',
      // Notices
      Notices: 'Notices',
      add_notice: 'Add notice',
      msg_added_notice: 'Notice added successfully.',
      msg_notice_updated: 'Notice modified successfully.',
      msg_notice_deleted: 'Notice removed successfully.',
      // Reports
      Reports: 'Reports',
      add_report: 'Add Report',
      msg_added_report: 'Report added successfully.',
      msg_report_updated: 'Report modified successfully.',
      msg_report_deleted: 'Report removed successfully.',
      // Casetas
      anadir_caseta: 'Add Guard House',
      mensaje_caseta_alta: 'Guard House Added Successfully.',
      mensaje_caseta_modificada: 'Guard House Modified Successfully.',
      mensaje_caseta_eliminada: 'Guard House Removed Successfully.',
      // Contactos
      contactos: 'Contacts',
      anadir_contacto: 'Add Contact',
      mensaje_contacto_alta: 'Contact Added Successfully.',
      mensaje_contacto_modificado: 'Contact Modified Correctly.',
      // Grupos
      grupos: 'Groups',
      anadir_grupo: 'Add Group',
      mensaje_grupo_alta: 'Group Added Successfully.',
      mensaje_grupo_modificado: 'Group Modified Successfully.',
      mensaje_grupo_delete: 'Group Removed Successfully.',
      eliminar: 'Delete',
      // ContactosXGrupo
      contactosXgrupo: 'Contacts By Group',
      mensaje_contactoXgrupo_alta: 'Contact Added Correctly to the Group.',
      mensaje_contactoXgrupo_delete: 'Contact Deleted from the Group Correctly.',
      // Invitaciones
      Filtrar: 'Filter',
      select_fecha: 'Select date:',
      mostrando_inv_dia: 'Showing invitations of the day:',
      mostrando_historial_dia: 'Showing History Day:',
      Fecha: 'Date',
      Visitante: 'Guest',
      Anfitrion: 'Host',
      hora_acceso: 'Entry time ',
      hora_salida: 'Departure time',
      Tipo: 'Type',
      no_registros_invit: 'There are no invitation records for that day.',
      // Accesos
      no_registros_accesos: 'There are no access records for that day.',
      // Accesos/Salidas
      mensaje_acercar_QR: 'Bring the QR code closer to the camera.',
      Leer: 'Read',
      enviar: 'Send',
      selecciona_caseta: 'Choose a Guard House',
      aceptar: 'Accept',
      no_resultados: 'No results',
      page_not_found: 'Page not found. !!!',
      page_not_found1: 'The requested URL',
      page_not_found2: 'was not found on this server.',
      inicio: 'Home',
      atras: 'Back',
      preregistro: 'Pre-registration',
      registro_exito: 'Data Sent Successfully',
      self_validate_exito: 'Data updated successfully',
      msj_cerrar_pagina: 'Your data is in the process of validation.',
      msj2_cerrar_pagina: 'Once validated you will be notified by SMS and / or E-Mail.',
      msj3_cerrar_pagina: 'Thank you for validating your information.',
      msj_cerrar_pagina_complemento: 'You can close this page.',
      identidad_exito: 'Identity Confirmed Correctly',
      identidad_exito2: 'Thank you for Confirming Identity',
      identidad_desconocido: 'Guest unrecognized.',
      identidad_desconocido2: 'Shortly this Guest will be removed from the System.',
      pgt_seguro: 'Are you sure you don\'t know the guest?',
      foto_perfil: 'Profile Picture',
      no_foto_perfil: 'Skip photo',
      confirmar_identidad: 'Confirm Identity',
      msg_know_guest: 'Do you recognize the Guest?',
      msg_notificacion_anfitrion: 'A Notification has been sent to the Host.',
      estado: 'Status',
      current: 'Current',
      canceled: 'Canceled',
      in_progress: 'In progress',
      done: 'Done',
      adentro: 'Inside',
      completado: 'Completed',
      subir_imagen: 'Upload Image',
      update_image: 'Update Image',
      qr_code: 'QR Code',
      msg_qr_code: 'Enter QR Code',
      invitados: 'Guest(s)',
      invitado: 'Guest',
      invitados_no_confirmados: 'Pending Guest(s)',
      placeholder_invitados: 'Search by E-Mail',
      placeholder_invitados2: 'Search by First name or Last name',
      placeholder_empresas: 'Search by Company',
      add_new_contact: 'Add New Contact',
      sign_up_new_contact: 'Register New Contact',
      add_new_employee: 'Add New Employee',
      invitacion_grupal: 'Group Invitation',
      pagina_caduca: 'This page has expired.',
      msg_update_data: 'Thank you for taking the time to update your information.',
      aviso: 'Notice',
      cancelar: 'Cancel',
      detalle: 'Detail',
      detalle_invit: 'Invitation Details',
      detalle_invit_recibidas: 'Detail of the Invitation Received',
      detalle_access: 'Access Details',
      detalle_access_without_code: 'Access Without Code Details',
      pendiente: 'Pending',
      info_acceso: 'ACCESS INFORMATION',
      fecha_hora_acceso_in: 'Date and Time of Access',
      fecha_hora_acceso_out: 'Date and time of departure',
      pase_salida: 'Pass out',
      confirmar: 'Confirm',
      email_admin: 'Email Manager',
      lbl_invit_empresarial: 'Business Invitation',
      lbl_host_company: 'Host Company',
      add_equipo_seguridad: 'Add security equipment',
      mensaje_areas_equipo_alta: 'Security Equipment Removed Successfully.',
      mensaje_areas_equipo_update: 'Security Equipment Modified Successfully.',
      mensaje_areas_equipo_delete: 'Security Equipment Removed Successfully.',
      lbl_invitacion_recurrente: 'Recurrent Invitation',
      Lunes: 'Monday',
      Martes: 'Tuesday',
      Miercoles: 'Wednesday',
      Jueves: 'Thursday',
      Viernes: 'Friday',
      Sabado: 'Saturday',
      Domingo: 'Sunday',
      lbl_selecciona_dias: 'Select days',
      access_days: 'Access days',
      normal: 'Normal',
      empresarial: 'Enterprise',
      recurrente: 'Recurrent',
      msg_eliminar_empleado: 'Are you sure to delete the Employee?',
      msg_eliminar_invitacion: 'Are you sure to delete the invitation?',
      msg_cancelar_invitacion: 'Are you sure to cancel the invitation?',
      msg_eliminar_invitacion_2: 'This action can not be undo',
      mensaje_invitacion_delete: 'Invitation Removed Successfully.',
      mensaje_invitacion_canceled: 'Invitation Canceled Successfully.',
      mensaje_empleado_delete: 'Employee Removed Successfully.',
      dias_validos: 'Valid Days',
      empresa_procedencia: 'Guest Company',
      mg_enviado: 'Message sent successfully',
      lbl_emergencia: 'Notice: An Emergency message will be sent to all guests within the Company.',
      msg: 'Message',
      recortar: 'Cut',
      recortar_imagen: 'Crop Image',
      frente: 'Front',
      reverso: 'Back',
      siguiente: 'Next',
      msg_no_days: 'You must select at least one day to continue.',
      cambiar_permisos: 'Change Permissions',
      cambiar_contrasena: 'Change Password',
      move_up_user_to_resident: 'User -> Resident',
      move_up_user_to_guard: 'User -> Guard',
      move_up_user_to_manager: 'User -> Manager',
      move_up_user_to_main_resident: 'User -> Main Resident',
      usuarios: 'Users',
      msg_cambio_permisos: 'Permissions changed successfully.',
      msg_invitacion_confirmada: 'Confirmed Invitation Successfully.',
      asistira: 'Will attend?',
      print_name_tag: 'Print name tag',
      // Footer
      a_cerca_de: 'About Us',
      equipo: 'Team',
      servicios: 'Services',
      contacto: 'Contact Us',
      sign_up_house: 'Sign Up Apartment',
      numero_casa: 'House Number',
      nombre_calle: 'Street Name',
      agregar_residente: 'Add Resident',
      editar_residente: 'Edit Resident',
      enviar_datos: 'Sending data  ...',
      intrare_residencial: 'Intrare Residency',
      validar_datos_vivienda: 'Validate Apartment Data',
      datos_vivienda: 'Apartment Data',
      datos_residente_principal: 'Main Resident Information',
      datos_residentes: 'Resident Data',
      detalle_residente: 'Resident Details',
      msg_reconoce_residentes: 'Do you recognize the residents?',
      continuar: 'Continue',
      paso: 'Step',
      acciones: 'Actions',
      configuracion: 'Settings',
      host_photo: 'Host photo',
      casas: 'Houses',
      who_authorized: 'Who authorized?',
      residente_principal: 'Main Resident',
      residentes: 'Residents',
      residente: 'Resident',
      main_residents: 'Main Residents',
      msg_eliminar_registros: 'Are you sure to delete the selected record (s)?',
      msg_eliminar_casa: 'Are you sure to remove the House?',
      msg_delete_lot: 'Are you sure to remove the Lot?',
      msg_eliminar_directory: 'Are you sure to remove the Record?',
      msg_delete_notice: 'Are you sure to remove the Notice?',
      msg_delete_report: 'Are you sure to remove the Report?',
      msg_eliminar_caseta: 'Are you sure to remove the Guard House?',
      msg_delete_manager: 'Are you sure to remove the Manager?',
      msg_delete_guard: 'Are you sure to remove the Guard?',
      msg_delete_resident: 'Are you sure to remove the Resident?',
      msg_delete_worker: 'Are you sure to remove the Worker?',
      msg_delete_contractor: 'Are you sure to remove the Contractor?',
      msg_delete_guest: 'Are you sure to remove the Guest?',
      msg_delete_main_resident: 'Are you sure to remove the Main Resident?',
      msg_enable_main_resident: 'Are you sure to enable the Main Resident?',
      msg_unlock_main_resident: 'Are you sure to Unlock the Main Resident??',
      msg_disable_main_resident: 'Are you sure to disable the Main Resident?',
      msg_block_main_resident: 'Are you sure to Block the Primary Resident?',
      msg_accion_deshacer: 'This action cannot be undone.',
      msg_contractor_send_info: 'Contractor information has been sent to the registered email.',
      msg_accion_enviar: 'The registered information will be sent to the contractor.',
      codigo_pais: 'Country Code',
      ejemplo: 'Example: ',
      cellphone_wrong: 'Wrong Cellphone Number.',
      msg_usuario_sin_permisos: 'User without permissions, contact the Manager.',
      msg_vigilant_sin_permisos: 'Guard without permissions, contact the Manager.',
      msg_user_delete: 'User Removed Successfully.',
      msg_user_invalidate: 'The guest has been notified to correct their data.',
      initialDate: 'Initial date',
      finalDate: 'Final date',
      add_guest: 'Add Guest',
      access_without_code: 'Access without Code',
      select_video_device: 'Select Video Device',
      start_camera: 'Start camera',
      stop_camera: 'Stop camera',
      capture_photo: 'Capture photo',
      notificaciones: 'Notifications',
      canSendEmail: 'Do you want to receive emails?',
      canSendSMS: 'Do you want to receive SMS?',
      notificacion_success: 'Settings Updated Successfully.',
      rulebook_uploaded_successfully: 'Rulebook uploaded successfully.',
      privacy_notice_uploaded_successfully: 'Privacy notice uploaded successfully.',
      msg_offline: 'There is no Internet Conection!',
      access_success: 'Access Registered Successfully.',
      msg_exit_time_registered: 'Exit Time Registered Successfully.',
      msg_captura_foto: 'Click on the video to capture the image.',
      search_by_number_street_phone: 'Search by street/house number/phone',
      search_by_number_street: 'Search by street or house number',
      search_by_street: 'Search by street',
      search_by_house_number: 'Search by House Number',
      search_by_street_house_number: 'Search by Street/House Number',
      search_by_house_number_resident: 'Search by Street/House Number/Resident Name',
      search_by_house_street_resident: 'Search by Street/Resident Name',
      search_by_name: 'Search by Name',
      search_by_code: 'Search by Code',
      service_catalog: 'Service Catalog',
      search_by_name_visitor: 'Search by Notes or Guest Name',
      search_by_address_notes_name_guest: 'Search by Address/Notes/Visitor Name',
      unique_resident: 'I am the only resident',
      msg_signup_apartment: 'To start Sign up Apartment Process, it is necessary to register a Main Resident, and the members of his family.',
      place_holder_housing_units: 'Search by name',
      validado: 'Validated',
      validar: 'Validate',
      msg_confirma_validacion_1: 'You must select ',
      or: 'or',
      msg_confirma_validacion_2: 'to continue.',
      habitada: 'Inhabited',
      deshabitada: 'Uninhabited',
      cambiar_wallpaper: 'Change wallpaper',
      cambiar_wallpaper_exito: 'Image Changed Successfully.',
      activar_desactivar: 'Enable/Disable',
      activar: 'Enable',
      desactivar: 'Disable',
      defaulter: 'Defaulter',
      block_for_non_payment: 'Block for non-payment',
      reactivate: 'Reactivate',
      unlock: 'Unlock',
      note_disable_main_resident: 'Note: By disabling the Main Resident, the Main Resident and the registered residents will not be able to send invitations.',
      note_block_main_resident: 'By blocking the Primary Resident, the intrare services will be disabled for him as well as for the Secondary Residents.',
      note2_block_main_resident: 'Note: Once the Primary Resident has been blocked, it will take 24 hours to remove the block.',
      note_enable_main_resident: 'Note: By activating the Main Resident, the Main Resident and the registered residents will be able to send invitations.',
      note_unlock_main_resident: 'Note: Unlocking the Primary Resident will enable intrare services for them, as for Secondary Residents.',
      servicio_suspendido: 'Suspended Service.',
      msg_time_unlock: 'It is not possible to remove the lock at this time. 24 hours must pass before trying again. Thank you for your patience.',
      msg_supendido: 'This message is displayed for any of the following 2 reasons:',
      msg_supendido1: 'Because you do not have permission to send invitations or',
      msg_supendido2: 'Due to non-payment, the invitation service has been suspended',
      msg_supendido3: 'For more information, contact your Principal Resident or Housing Unit Manager.',
      blocked_service: 'Blocked service',
      dear_user: 'Dear user',
      msg_blocked_service_01: 'We inform you that your account has been blocked due to an outstanding balance due to the maintenance service of your private account.',
      msg_blocked_service_02: 'To reactivate your account and restore full access to our services, we ask that you immediately contact your Privacy Administration department.',
      importar_casas: 'Houses Import',
      importar: 'Import',
      selecciona_archivo: 'Pick a Excel file.',
      selecciona_archivo_pdf: 'Pick a PDF file.',
      archivo: 'File',
      importar_casas_archivo: 'Import houses from Excel file.',
      import_account_statements_file: 'Import account statements from excel file.',
      msg_importar_casas: 'Note: The file to import houses must comply with the following format.',
      mostrar_formato: 'Show format',
      msg_mi_codigo: 'My Access Code',
      descargar: 'Download',
      renovar_codigos: 'Update QR codes',
      renovar_codigos_residentes: 'Update QR codes of residents',
      msg_update_code_1: 'Allow Monthly update of Resident QR Codes automatically.',
      msg_update_code_2: 'Note: This update takes place on the first day of each month at 3:00 AM.',
      allow: 'Allow',
      cambios_aplicados: 'Changes Successfully Applied',
      label: 'Label',
      classification: 'Classification',
      device: 'Device',
      no_devices: 'No Devices',
      no_lots: 'No registered lots .',
      add_device: 'Add Device',
      device_added_successfully: 'Device added successfully.',
      device_modified_successfully: 'Device Modified successfully.',
      device_removed_successfully: 'Device removed successfully.',
      lot_removed_successfully: 'Lot removed successfully.',
      device_by_guardhouse: 'Device(s) by Guardhouse',
      delete: 'Delete',
      delete_question: 'Delete question',
      change: 'Change',
      show_devices: 'Show Device(s)',
      show_lots: 'Show Lots',
      show_details: 'Show details',
      send_details: 'Send details',
      msg_info_details: 'This information is only visible to the Administrator.',
      msg_send_contractor: 'Send contractor information',
      details: 'Details',
      lanesQR: 'Lanes with QR Reader',
      lanesCam: 'Lanes with Camera',
      devices: 'Devices',
      grados: 'Degrees',
      msg_can_not_delete_house01: 'It is not possible to delete the House.',
      msg_can_not_delete_house02: 'Currently one or more Residents are occupying it. Eliminate the Resident first.',
      no_records_yet: 'No records yet.',
      canceled_invitation: 'CANCELED INVITATION!',
      msg_canceled_invitation_offline: 'This invitation has been canceled by the Host.',
      msg_canceled_invitation: 'ACCESS DENIED! This invitation has been canceled by the Host.',
      msg_event_canceled: 'ACCESS DENIED!. This event has been canceled by the Host.',
      msg_vacation_mode_activate: 'ACCESS DENIED! At the moment the house is not receiving visitors.',
      msg_out_date: 'ACCESS DENIED! This invitation is out of date or has expired.',
      msg_out_date2: 'ACCESS DENIED!. This invitation has expired.',
      msg_out_date3: 'ACCESS DENIED!. Entry is not authorized for this day.',
      msg_out_date_worker0: 'ACCESS DENIED!. This worker is not authorized entry for this day.',
      msg_out_date_worker1: 'ACCESS DENIED!. The deadline to access this worker has expired.',
      msg_out_date_contractor0: 'ACCESS DENIED!. This contractor is not authorized entry for this day.',
      msg_out_date_contractor1: 'ACCESS DENIED!. The deadline to access this contractor has expired.',
      msg_out_date_contractor2: '!ACCESS DENIED!. Contractor Blocked. Contact the Subdivision Administrator.',
      export_to_pdf: 'Export to PDF',
      access_report_no_code: 'Access report no code',
      period: 'Period: ',
      page: 'Page ',
      al: ' to ',
      de: ' of ',
      allow_device: 'Allow device',
      show_current_invitations: 'Show current invitations',
      msg_allow_device: 'Do you want the Vigilante to log in from this Browser?',
      show_house_phones: 'Show house phones',
      msg_allow_show_house_phones: 'Do you want the Watchers to be able to see the house phones?',
      msg_allow_show_current_invitations: 'Do you want the Watchers to be able to see the current invitations of the day?',
      msg_enable_ine_photo: 'What photo of the host do you want the guard to show when displaying the invitation information?',
      info_enable_ine_photo: 'Note: By activating this option, the guards will be able to see the ID of the guest, so the treatment given to the information presented is the responsibility of the client.',
      booth_registration: 'Booth registration',
      notice: 'Notice',
      title: 'Title',
      comments: 'Comments',
      no_comment: 'No Comments',
      administrator_comments: 'Administrator comments',
      file: 'File',
      msg_overflow_file: 'File size should be less than 2 MB!',
      type_reports: 'Type of reports',
      choose_category: 'Choose a category',
      evidence: 'Evidence',
      msg_evidence: 'If you want to add a photo as evidence, check the Add File box and then select the photo.',
      no_vidence: 'No evidence attached.',
      directory: 'Directory',
      show_vehicle_plates: 'Show vehicle plates',
      vehicle_plates: 'Vehicle plates',
      send_email_update: 'Send email, data validation/update',
      hide_video: 'Hide video',
      show_video: 'Show video',
      show_qr_code: 'Show QR code',
      display_info_print: 'Display information to print',
      generate_pdf_printing: 'Generate PDF for printing',
      number_cards_sheet: 'Number of cards per sheet',
      supplier: 'Supplier',
      q_supplier: 'Is a Supplier?',
      supplier_mode: 'Supplier mode: ',
      msg_supplier: 'This person has been invited in supplier mode, please carry out the security protocol for suppliers.',
      tooltip_supplier: 'If your visit is going to perform any service or delivery at your home, tell the subdivision to expedite their entry and that the security protocol for suppliers is carried out.',
      account_statements: 'Account statements',
      relate_home: 'Relate home',
      vacation_mode: 'Vacation Mode: ',
      msg_vacation_mode: 'At the moment the house is not receiving visitors.',
      allow_access_visitors: 'Allow access to visitors',
      allow_access_residents: 'Allow access to residents',
      allow_access_workers: 'Allow access workers',
      rulebook: 'Rulebook',
      rulebook_upload_tooltip: 'Here you can upload the subdivision internal rulebook',
      privacy_notice: 'Privacy notice',
      privacy_notice_upload_tooltip: 'Here you can upload the subdivision privacy notice',
      guardhouse_name_checkin: 'Guardhouse Check-In',
      guardhouse_name_checkout: 'Guardhouse Check-Out',
      current_invitations: 'Current invitations',
      data_correction_form: 'Data correction form',
      data_correction: 'Data correction',
      msg_photograph_blurred: 'Official identification photograph is indistinguishable (blurred)',
      send_correction_request: 'Send correction request',
      data_correction_sent: 'Data correction sent.',
      additional_comments: 'Additional comments',
      msg_additional_comments: 'Write additional comments. \nNote: these comments will be attached to the email.',
      additional_person: 'Additional person',
      msg_additional_person: 'The guest comes with more people',
      show_additional_people: 'Show additional people',
      additional_people: 'Additional people',
      show_all_residents: 'Show all residents',
      show_secondary_residents: 'Show secondary residents',
      msg_no_registered_secondary_residents_yet: 'This Primary Resident has not registered Secondary Residents yet.',
      register: 'Register',
      register_parcel: 'Register parcel',
      addressee: 'Addressee',
      guide_number: 'Guide number',
      company: 'Company',
      who_delivered: 'Who delivered?',
      who_received: 'Who received?',
      package_delivery: 'Package delivery',
      water_service_delivery: 'Water service delivery',
      parcel: 'Parcel',
      parcel_capital_letters: 'PARCEL',
      date_time_receipt: 'Date time receipt',
      delivery_date_time: 'Delivery date time',
      date_time_request: 'Date time of request',
      in_booth: 'In booth',
      delivered: 'Delivered',
      requested: 'Requested',
      payroll_number: 'Payroll number',
      email: 'E-Mail',
      msg_delete_alert: 'Use this tool with caution as once you remove the guest you will no longer be able to recover their information.',
      guest_management: 'Guest management',
      event_data: 'Event information',
      event: 'Event',
      events: 'Events',
      event_name: 'Event name',
      event_time: 'Time',
      code: 'Code',
      instructions: 'Instructions',
      sincronizar: 'Synchronize',
      notify_on_no_code_access: 'Notify on no code access',
      notify_on_worker_access: 'Notify on worker access',
      personal_information: 'Personal Information',
      configuration_permissions: 'Configuration Permissions',
      authentication: 'Authentication',
      identification_photos: 'Identification Photos',
      full_name: 'Full Name',
      error_name_min_two_words: 'The name must contain at least one last name (minimum 2 words).',
      pet_registrations: 'Pet Registrations',
      pet_name: 'Pet Name',
      pet_report: 'Pet Registration Report',
      fecha_registro: 'Registration Date',
      receive_marketplace_notifications: 'Do you want to receive marketplace notifications?',
      visualizar: 'View',
      // Tickets System
      sistema_tickets: 'Tickets System',
      mis_tickets: 'My Support Tickets',
      crear_ticket: 'Create New Ticket',
      detalles_ticket: 'Ticket Details',
      lista_tickets: 'Tickets List',
      nuevo_ticket: 'New Ticket',
      titulo: 'Title',
      descripcion: 'Description',
      area: 'Area',
      nombre_cliente: 'Client Name',
      cliente: 'Client',
      fecha_creacion: 'Creation Date',
      no_hay_tickets: 'No tickets available',
      total_tickets: 'Total Tickets',
      nuevos: 'New',
      en_progreso: 'In Progress',
      resueltos: 'Resolved',
      etiquetas: 'Tags',
      no_disponible: 'Not Available',
      foto_no_disponible: 'Photo not available',
      debes_iniciar_sesion: 'You must log in to see your tickets',
      acceso_no_autorizado: 'Unauthorized Access',
      solo_administradores: 'Only administrators can access this section',
      // Frequently Asked Questions
      preguntas_frecuentes: 'Frequently Asked Questions',
      buscar_preguntas: 'Search questions...',
      no_preguntas_encontradas: 'No questions found matching your search',
      ayuda: 'Help Center',
      catalog_worker: 'Catalog of Workers',
      select_worker_deleted: 'Select a worker from the catalog (Optional)',
      // Surveys
      surveys: 'Surveys',
      survey: 'Survey',
      add_survey: 'Add Survey',
      survey_results: 'Survey Results',
      survey_title: 'Survey Title',
      survey_description: 'Description',
      survey_start_date: 'Start Date',
      survey_end_date: 'End Date',
      add_questions: 'Add Questions',
      survey_questions: 'Questions',
      msg_added_survey: 'Survey added successfully.',
      msg_survey_updated: 'Survey updated successfully.',
      msg_survey_deleted: 'Survey deleted successfully.',
      msg_delete_survey: 'Are you sure to delete the Survey?',
      survey_status: 'Status',
      question_text: 'Question',
      question_type: 'Question Type',
      SINGLE_CHOICE: 'Single Choice',
      MULTIPLE_CHOICE: 'Multiple Choice',
      TEXT: 'Free Text',
      options: 'Options',
      add_option: 'Add Option',
      add_question: 'Add Question',
      save_questions: 'Save Questions',
      msg_questions_added: 'Questions added successfully.',
      view_results: 'View Results',
      close_survey: 'Close Survey',
      pending_surveys: 'Voting/Pending Surveys',
      answer_survey: 'Answer Survey',
      submit_answers: 'Submit Answers',
      msg_survey_submitted_successfully: 'Survey submitted successfully.',
      msg_no_pending_surveys: 'You have no pending surveys at the moment.',
      survey_preview: 'Preview',
      msg_no_questions_yet: 'This survey does not have any questions yet.',
      download_pdf: 'Download PDF',
      voting: 'Voting',
      add_voting: 'Add Voting',
      voting_title: 'Voting Title',
      voting_description: 'Description',
      voting_end_date: 'End Date',
      voting_question: 'Question',
      voting_question_type: 'Question Type',
      voting_options: 'Options',
      msg_added_voting: 'Voting added successfully.',
      common_areas: 'Common Areas',
      common_area: 'Common Area',
      add_common_area: 'Add Common Area',
      edit_common_area: 'Edit Common Area',
      delete_common_area: 'Delete Common Area',
      msg_delete_common_area: 'Are you sure to delete the Common Area?',
      msg_common_area_added: 'Common Area added successfully.',
      msg_common_area_updated: 'Common Area updated successfully.',
      msg_common_area_deleted: 'Common Area deleted successfully.',
      name_common_area: 'Common Area Name',
      location_common_area: 'Common Area Location',
      description_common_area: 'Common Area Description',
      capacity_common_area: 'Common Area Capacity',
      max_hours_per_reservation: 'Max. Hours per Reservation',
      reservation_interval: 'Reservation Interval',
      color_calendar: 'Color in Calendar',
      image: 'Image',
      has_price: 'Has Price?',
      price: 'Price',
      create_common_area: 'Create Common Area',
      requires_authorization: 'Requires Authorization?',
      active: 'Active?',
      save_changes: 'Save Changes',
      view_common_areas: 'View Common Areas',
      view_common_area_schedule: 'View Common Area Schedule',
      reservation: 'Reservations',
      // Storage (Home - Admin Card)
      almacenamiento: 'Storage',
      usado: 'Used',
      disponible: 'Available',
      total: 'Total',
      limite: 'Limit',
      este_mes: 'This month',
      almacenamiento_historico: 'Historic storage',
      almacenamiento_reciente: 'Recent storage',
      total_historico: 'Total historic',
      fotos: 'Photos',
      documentos: 'Documents',
      eventos: 'Events',
      optimo: 'Optimal',
      alerta: 'Warning',
      critico: 'Critical',
      solicitar_espacio: 'Request more space',
      solicitar_almacenamiento: 'Request Additional Storage',
      solicitar_almacenamiento_subtitulo: 'Expand your housing unit\'s storage capacity',
      uso_actual: 'Current usage',
      mas_popular: 'Most popular',
      por_mes: '/month',
      paquete_descripcion_5gb: 'Additional storage',
      paquete_descripcion_10gb: 'Recommended plan',
      paquete_descripcion_20gb: 'For more content',
      paquete_descripcion_50gb: 'Professional plan',
      activacion_inmediata: 'Immediate activation',
      sin_permanencia: 'No commitment',
      facturacion_mensual: 'Monthly billing',
      soporte_prioritario: 'Priority support',
      paquete_seleccionado: 'Selected package',
      ningun_paquete_seleccionado: 'Select a package to continue',
      solicitud_enviada: 'Your request for the {paquete} package has been sent successfully.',
      error_cargar_almacenamiento: 'Error loading storage',
      verifica_permisos: 'Check your permissions or try again later',
      reintentar: 'Retry',
      cargando_almacenamiento: 'Loading storage information...',
      hace_un_momento: 'Just now',
      error_solicitud_almacenamiento: 'Error sending storage request',
      almacenamiento_adicional: 'Additional Storage',
      duracion_plan: 'Plan Duration',
      precio_por_mes: 'Price per month',
      meses: 'Months',
      subtotal: 'Subtotal',
      descuento: 'Discount',
      paquete_descripcion_100gb: 'Enterprise plan',
      paquete_descripcion_200gb: 'Premium plan',
      restricted_people: 'Restricted People',
      communication_channel: 'Chats'
    }
  }
})
